<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current='page'>
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="this.$store.state.user.roleType !== 2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>

            <!-- <label>商品搜索:</label>
            <lk-input placeholder='请输入商品名，通用名，商品编码，助记码' class="item" clearable v-model.trim="query.nameMix"></lk-input> -->
          </div>
          <div class="queryItem">

          <label>商品类型:</label>
          <lk-select class="item" v-model="query.goodsType" clearable>
            <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
  <div class="queryItem">
            <label>生产企业:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.producer"></lk-input>
          </div>
  <!-- <div class="queryItem">
            <label>药品上市许可持有人:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.mah"></lk-input>
          </div> -->
           <div class="queryItem">
            <label>供应商名称:</label>
            <SupplierListSelect v-model='query.supplierId'/>
          </div>
          <div class="queryItem">
            <label>批准文号/注册证号:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.approvalCode"></lk-input>
          </div>
          <div class="queryItem">
            <label>单据号:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.code"></lk-input>
          </div>

          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker type='daterange'  placeholder='请选择' class="item" v-model="query.duration"></timeStampDatePicker>
          </div>

          <!-- <div class="queryItem">
            <label>结束时间:</label>
            <lk-DatePicker placeholder='请选择' class="item" v-model.trim='query.endTime'></lk-DatePicker>
          </div> -->
          <div class="queryItem">
            <label>是否DTP:</label>
            <lk-select v-model='query.isDtp' class="item">
              <lk-option v-for="(item, index) in bool" :key="index" :value="index + 1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>储存条件:</label>
            <lk-select v-model='query.storageCondition' class="item">
              <lk-option v-for="(item, index) in storageConditionsList" :key="index" :value="item.dictionaryIndex">{{item.dictionaryName}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem storeSelect">
            <label>GSP分类:</label>
            <lk-select v-model='query.gspIdList' class="item" filterable multiple>
              <lk-option v-for="(item, index) in gspList" :key="index" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>进项税率:</label>
            <lk-select v-model='query.inputTaxRate' class="item">
              <lk-option v-for="(item, index) in taxRateList" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>批号:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.batchCode"></lk-input>
          </div>
            <!-- <div class="queryItem">
            <label>生产日期:</label>
            <timeStampDatePicker  placeholder='请选择' class="item" v-model="query.prodDate"></timeStampDatePicker>
          </div>
            <div class="queryItem">
            <label>有效期至:</label>
            <timeStampDatePicker  placeholder='请选择' class="item" v-model="query.expiryDate"></timeStampDatePicker>
          </div> -->
          <div class="queryItem">
            <label>批次:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.batchSeq"></lk-input>
          </div>

          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch()">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
            <!--<lk-button class="mr" @click="download" v-if="this.handlePermission('recipeSalesQueryExcel')">导出Excel</lk-button>-->
          </div>
        </div>
      </div>

      <div slot="table">
        <!-- 异步导出Excel Start -->
        <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('purchaseReturnsDetailDownload')"></DownloadButton>
        <!-- 异步导出Excel End -->

        <!-- 合计信息 Start -->
        <!-- <SummaryInfo :data="summary"></SummaryInfo> -->
        <!-- 合计信息 End -->
        <lk-table border :columns='columns' :data='tableData'/>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
// import SummaryInfo from './SummaryInfo';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
// import system from '../../services/system';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import goodsService from '../../services/goods';
import DownloadButton from '../../components/download/DownloadButton';


export default {
  name: 'PurchaseReturnsDetails',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    SupplierListSelect,
    // SummaryInfo,
    DownloadButton,
  },
  computed: {
    ...mapGetters(['getNormalGoodsTypes']),
    taxRateList() {
      return this.$store.state.publicParams.taxRateList;
    },
  },
  data() {
    return {
      // taxRateList: [0, 3, 6, 9, 13],

      gspList: [],
      storageConditionsList: [],
      summary: {},
      query: {
        orderNo: '',
        nameMix: '',
        manufacturer: '',
        startTime: null,
        endTime: null,
        storeIdList: [],
        duration: [],
        isDtp: '',
        storageCondition: '',
        gspList: [],
        purchaseType: 1,
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 58,
          tooltip: true,
          fixed: 'left',
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '门店名称', key: 'storeName', minWidth: 116, tooltip: true,
        },
        {
          title: '业务日期', key: 'createTime', minWidth: 116, tooltip: true,
        },
        {
          title: '单据类型', key: 'typeName', minWidth: 116, tooltip: true,
        },
        {
          title: '单据号', key: 'code', minWidth: 116, tooltip: true,
        },
        {
          title: '供应商', key: 'inventoryInfoSupplierName', minWidth: 116, tooltip: true,
        },
        {
          title: '商品编码', key: 'goodsInfoVoDrugSerialCode', minWidth: 116, tooltip: true,
        },
        {
          title: '商品类型', key: 'inventoryInfoGoodsTypeName', minWidth: 116, tooltip: true,
        },
        {
          title: '采购来源', key: 'inventoryInfoPurchaseTypeName', minWidth: 116, tooltip: true,
        },
        {
          title: '商品名称', key: 'goodsInfoVoGoodsName', minWidth: 116, tooltip: true,
        },
        {
          title: '通用名', key: 'goodsInfoVoApprovedDrugName', minWidth: 116, tooltip: true,
        },
        {
          title: '是否DTP', key: 'goodsInfoVoIsDtp', minWidth: 116, tooltip: true,
        },
        {
          title: '批准文号/注册证号', key: 'goodsInfoVoApprovalCode', minWidth: 116, tooltip: true,
        },


        {
          title: '规格', key: 'goodsInfoVoSpec', minWidth: 116, tooltip: true,
        },
        {
          title: '产地', key: 'goodsInfoVoCountryOfOrigin', minWidth: 116, tooltip: true,
        },
        {
          title: '剂型', key: 'goodsInfoVoDosageFormName', minWidth: 116, tooltip: true,
        },
        {
          title: '生产企业', key: 'goodsInfoVoProducer', minWidth: 116, tooltip: true,
        },
        {
          title: '药品上市许可持有人', key: 'goodsInfoVoMah', minWidth: 116, tooltip: true,
        },
        {
          title: '单位', key: 'minPkgUnitName', minWidth: 116, tooltip: true,
        },
        {
          title: '储存条件', key: 'goodsInfoVoStorageConditionName', minWidth: 116, tooltip: true,
        },
        {
          title: 'GSP分类', key: 'goodsInfoVoGsps', minWidth: 116, tooltip: true,
        },
        {
          title: '单价', key: 'price', minWidth: 116, tooltip: true,
        },
        {
          title: '不含税单价', key: 'priceWithoutTax', minWidth: 116, tooltip: true,
        },
        {
          title: '进货/退货数量', key: 'num', minWidth: 116, tooltip: true,
        },
        {
          title: '进项税率', key: 'taxRate', minWidth: 116, tooltip: true,
        },
        {
          title: '总含税金额', key: 'amount', minWidth: 116, tooltip: true,
        },
        {
          title: '税额', key: 'totalTax', minWidth: 116, tooltip: true,
        },
        {
          title: '批号', key: 'inventoryInfoGoodsBatchNumber', minWidth: 116, tooltip: true,
        },
        {
          title: '生产日期',
          key: 'inventoryInfoGoodsProductionDate',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '有效期至', key: 'inventoryInfoGoodsExpiryDate', minWidth: 116, tooltip: true,
        },
        {
          title: '批次', key: 'inventoryInfoGoodsBatchSeq', minWidth: 116, tooltip: true,
        },

      ],
      tableData: [],
      types: [],
      bool: ['是', '否'],
      gender: ['男', '女'],
    };
  },
  methods: {
    clear() {
      this.query = { duration: [] };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.params.createTimeStart = this.params.duration[0];
      this.params.createTimeEnd = this.params.duration[1];


      purchase
        .getlistInspectRefundReport(this.params)
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            this.count = res.data.data.count;
            res.data.data.list.forEach((item) => {
              const result = {};
              utils.exchangeTable(item, result);
              result.createTime = utils.formatDate(result.createTime);
              result.inventoryInfoGoodsProductionDate = utils.formatDate(result.inventoryInfoGoodsProductionDate);
              result.inventoryInfoGoodsExpiryDate = utils.formatDate(result.inventoryInfoGoodsExpiryDate);
              // console.log(result);
              result.taxRate += '%';

              // result.saleOrderDetailCreateTime = utils.formatDate(result.saleOrderDetailCreateTime);
              result.goodsInfoVoIsDtp = this.bool[result.goodsInfoVoIsDtp - 1];
              // result.saleOrderDetailIsEphedrine = this.bool[result.saleOrderDetailIsEphedrine - 1];
              // result.salePrescriptionPatientGender = this.gender[result.salePrescriptionPatientGender - 1];
              // result.isDtpStr = this.bool[result.saleOrderDetailIsDtp - 1];
              // // result.saleOrderDetailRealPrice /= 100;
              // // result.saleOrderDetailAmount /= 100;
              // result.loading = false;
              // result.saleOrderDetailManufactureDate = utils.exchangeTime(result.saleOrderDetailManufactureDate);
              // result.saleOrderDetailExpireDate = utils.exchangeTime(result.saleOrderDetailExpireDate);
              // result.profitRate += '%';
              // result.profitRateWithoutTax += '%';
              this.tableData.push(result);
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    // getDetailSummary() {
    //   purchase.getDetailSummary(this.params).then((res) => {
    //     if (res.data.status === 200) {
    //       this.summary = res.data.data;
    //     } else {
    //       this.$Message.error(res.data.error);
    //     }
    //   }).catch((err) => {
    //     utils.handleError(err);
    //   });
    // },
    download() {
      const params = utils.deepClone(this.query);
      params.page = 0;
      params.size = 0;
      params.createTimeStart = params.duration[0];
      params.createTimeEnd = params.duration[1];
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      purchase.downloadListInspectRefundReport(params).then((res) => {
        // utils.downLoadExcel(res, '处方药销售记录查询');
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getStorageConditionsList() {
      goodsService.GoodsDictionary({ dictionaryTypeEnum: 9 }).then((res) => {
        if (res.data.status === 200) {
          this.storageConditionsList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getGSPList() {
      goodsService.listGoodsLabels({ categoryId: 1 }).then((res) => {
        if (res.data.status === 200) {
          this.gspList = res.data.data.list;// .filter(item => item.name.includes('RX'));
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getStorageConditionsList();
    this.getGSPList();
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>

</style>
